/**
 * Block functions
 */

var component_block_functions = function(args) {

  const columns = args.columns;

  // get screen width
  var screen_w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

  // return if not mobile
  if (screen_w > 782) {
    return false;
  }

  // validate
  if (!columns) {
    console.log('no columns  suplied');
    return;
  }

  /**
   * Init
   */
   function init_component_block_functions() {

    // change column order in mobile
    columns.forEach((item) => {
      var first_col = item.children[0];
      item.appendChild(first_col);
    });

    return;
  }
  init_component_block_functions();

  // make the call chainable
  return this;
};
